// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"ae22043bc17c3778","table":"b02df8a5ed59de03","wrapper":"d21a277391508ab8","edit":"ee8e94cb5ef71d8f","editCell":"_40387bb8b7f0b4c5","editColumn":"_03f95a99ab857de1"};